import { render, staticRenderFns } from "./actuals_billing_report_tbn.vue?vue&type=template&id=284e5552&scoped=true&"
import script from "./actuals_billing_report_tbn.vue?vue&type=script&lang=js&"
export * from "./actuals_billing_report_tbn.vue?vue&type=script&lang=js&"
import style0 from "./actuals_billing_report_tbn.vue?vue&type=style&index=0&id=284e5552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e5552",
  null
  
)

export default component.exports